import { ModelSnippetFn } from '../types';

const getOpenAIClientSnippet = ({ userId, appId, modelId }: { userId: string; appId: string; modelId: string; pat?: string }) => `\
import OpenAI from "openai";

const client = new OpenAI({
  baseURL: "https://api.clarifai.com/v2/ext/openai/v1",
  apiKey: "REPLACE_WITH_YOUR_CLARIFAI_PAT",
});

const response = await client.chat.completions.create({
  model: "https://clarifai.com/${userId}/${appId}/models/${modelId}",
  messages: [
    {"role": "system", "content": "Talk like a pirate."},
    {
      "role": "user",
      "content": "How do I check if a Python object is an instance of a class?",
    },
  ],
});

console.log(response);
`;

export const generateNodeSDKForLLMOpenAI: ModelSnippetFn = ({ userId, appId, modelId, pat }) => {
  return getOpenAIClientSnippet({
    userId,
    appId,
    modelId,
    pat: pat && pat !== 'YOUR_PAT_HERE' ? `"${pat}"` : 'process.env.CLARIFAI_PAT',
  });
};
